<div class="messages-wrapper" *ngIf="chatMessages().length > 0 || VariableParsedData().trim().length > 0">
    <div class="messages-header">
        <h3 class="title">{{title()}}</h3>
        <div class="close-msg" (click)="closeChatViewer()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="ppk20d5f8a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <path fill="#D9D9D9" d="M0 0h24v24H0z"/>
                </mask>
                <g mask="url(#ppk20d5f8a)">
                    <path d="m6 6 12 12M6 18 18 6" stroke="#0F1A2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
            </svg>            
        </div>
    </div>
    <div class="messages-container">
        <div *ngIf="chatMessages().length > 0">
            <ng-container
                *ngFor="let message of chatMessages(); let i = index">
                <div *ngIf="message.question" class="message-description"[style.white-space]="'pre-wrap'"
                    [innerHTML]="message.question"
                    >
                </div>
                <div *ngIf="message.answer" class="bot-message-description">
                    <div class="bot-msg-icon">
                        <span><img
                                src="/assets/icons/vibrant-m.svg" alt="vibrant-m"></span>
                    </div>
                    <div class="bot-msg-description">
                        <div [innerHTML]="message.answer"></div></div>
                </div>
            </ng-container>      
        </div>
        <div class="citation-var-input" *ngIf="citationType =='variable_input'">
            <div [innerHTML]="VariableParsedData()"></div>
        </div>   
    </div>
</div>